import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NewsLetterSubscriptionURLService } from '../urls/newslettersubscription.url';
import { NewsLetterSubscriptionDTO } from '../interfaces/newslettersubscription.interface.ts/newsletter-subscription-dto.interface';
import { PagedAPIResponse } from '../interfaces/generalinterface/paged-api-response.interface';

@Injectable({
    providedIn: 'root'
})
export class NewsLetterSubscriptionAPIService {
    private httpClient = inject(HttpClient);
    private newsLetterSubscriptionURLService = inject(NewsLetterSubscriptionURLService);



    public AddNewsLetterSubscriptionData(data: NewsLetterSubscriptionDTO): Observable<string> {
        return this.httpClient.post<string>(this.newsLetterSubscriptionURLService.AddNewsLetterSubscriptionURL(), data);
    }

    public GetNewsLetterSubscriptionList(): Observable<PagedAPIResponse<NewsLetterSubscriptionDTO[]>> {
        return this.httpClient.get<PagedAPIResponse<NewsLetterSubscriptionDTO[]>>(this.newsLetterSubscriptionURLService.GetNewsLetterSubscriptionListURL());
    }


}
